import * as React from 'react';

type Props = {
    content: React.ReactNode;
    maxHeight: number;
};

export function TruncatedElement(props: Props) {
    const {content, maxHeight} = props;

    const [maxElementHeight, setMaxElementHeight] = React.useState<number | null | undefined>(
        undefined
    );
    const elementRef = React.useRef(null);

    React.useLayoutEffect(() => {
        if (elementRef && elementRef.current) {
            setMaxElementHeight(
                // @ts-expect-error
                elementRef.current.clientHeight <= maxHeight
                    ? // @ts-expect-error
                      elementRef.current.clientHeight
                    : maxHeight
            );
        }
    }, [maxHeight]);

    return (
        // @ts-expect-error
        <div ref={(r) => (elementRef.current = r)}>
            {/* @ts-expect-error */}
            <div style={{maxHeight: maxElementHeight, overflow: 'hidden'}}>{content}</div>
            {maxElementHeight &&
            elementRef.current &&
            // @ts-expect-error
            elementRef.current.clientHeight > maxElementHeight ? (
                <div>…</div>
            ) : undefined}
        </div>
    );
}
